import { render } from "./RegulationsAndPrivacy.vue?vue&type=template&id=3a15486a&scoped=true&ts=true"
import script from "./RegulationsAndPrivacy.vue?vue&type=script&lang=ts"
export * from "./RegulationsAndPrivacy.vue?vue&type=script&lang=ts"

import "./RegulationsAndPrivacy.vue?vue&type=style&index=0&id=3a15486a&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a15486a"]])

export default __exports__